import fetchWith403Redirect from './fetchWith403Redirect';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/settlement-dates`;

export async function getSettlementDates() {
  const res = await fetchWith403Redirect(API_URL, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
  return res.json();
}

// Only settlement dates with vouchers
export async function getSettlementDatesWithVouchers() {
  const res = await fetchWith403Redirect(API_URL + '/with-vouchers', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
  return res.json();
}

/** Union of scheduled periods (GET /) and any period that already has vouchers — so upcoming empty periods still appear for imports. */
export async function getSettlementDatesForWorkspace() {
  const [all, withV] = await Promise.all([getSettlementDates(), getSettlementDatesWithVouchers()]);
  const listAll = Array.isArray(all) ? all : [];
  const listV = Array.isArray(withV) ? withV : [];
  const byId = new Map();
  for (const d of listV) {
    if (d?.id != null) byId.set(String(d.id), d);
  }
  for (const d of listAll) {
    if (d?.id != null) byId.set(String(d.id), d);
  }
  return [...byId.values()].sort((a, b) => new Date(b.settlement_date) - new Date(a.settlement_date));
}
